import { RunStateTransition } from "types/generated";
import RetryRunButton from "components/Run/elements/RetryRunButton";
import Box from "ds/components/Box";

import CanceledEntry from "../entries/CanceledEntry";
import { RunEntryContext } from "../types";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createCanceledEntry = (
  { timestamp, username, stateVersion }: RunStateTransition,
  { isModuleRun, canRetry, runRetryBlocker, stackId, runId }: RunEntryContext
) => {
  return (
    <CanceledEntry
      key={getRunStateTransitionId(timestamp, stateVersion)}
      timestamp={timestamp}
      username={username}
    >
      {isModuleRun && (canRetry.result || canRetry.message || runRetryBlocker) && (
        <Box gap="medium">
          <RetryRunButton
            runId={runId}
            stackId={stackId}
            runRetryBlocker={runRetryBlocker}
            errorMessage={canRetry.message}
            isModuleRun
          />
        </Box>
      )}
    </CanceledEntry>
  );
};
